module.exports = __webpack_public_path__ + "static/media/header-imbera.14afba49.png";